(ns app.account-settings.styles
  (:require-macros)
  (:require
   [spade.core   :refer [defglobal defclass]]))


(defclass settings-card
  []
  {:background "white"
   :padding "22px 33px"
   :border-radius "10px"
   :border "1px solid"
   :border-color :theme/*grey400*})


(defclass settings-panel
  []
  {:padding-top "23px"})
